import { FC, ReactNode } from "react";
import classes from './penaltiesBonuses.module.scss'
import { LabelText } from "../../../../shared/ui/sign";
import { formatUtcToMsk } from "../../../../shared/lib/helpers/formatUtcToMsk";
import { IPenaltyBonusItem, IPenaltyBonusSummary } from "../../model/types";
import { DeleteAction } from "../../../../features/deleteAction";

interface IProps {
    items: IPenaltyBonusItem[];
    summary: IPenaltyBonusSummary;
    onDelete: (item: IPenaltyBonusItem) => Promise<void>;
    canDelete?: boolean;
    renderMeta?: (item: IPenaltyBonusItem) => ReactNode;
    bonusLabel?: string;
    penaltyLabel?: string;
}

export const PenaltiesBonuses: FC<IProps> = ({
    items,
    summary,
    onDelete,
    canDelete=true,
    renderMeta,
    bonusLabel = 'Премия',
    penaltyLabel = 'Штраф',
}) => {
    const bonusLabelLower = bonusLabel.toLowerCase()
    const penaltyLabelLower = penaltyLabel.toLowerCase()

    return (
        <section className={classes.container}>
            <section className={classes.total}>
                <span>Всего ({bonusLabelLower}): {summary.bonuses}</span>
                <span>Всего ({penaltyLabelLower}): {summary.penalties}</span>
            </section>
            <section className={classes.items}>
                {items.map(item => 
                    <section
                        key={item.id}
                        className={classes.item}
                    >
                        <section className={classes.header}>
                            <section className={classes.amountBox}>
                                <section 
                                    className={classes.type + (item.type === 'bonus' ? ` ${classes.bonus}` : '')}
                                >
                                    {
                                        item.type === 'bonus' 
                                            ? 
                                        bonusLabel
                                            : 
                                        penaltyLabel
                                    }
                                </section>
                                &nbsp;на сумму&nbsp;
                                <section className={classes.amountWrap}>
                                    <span className={classes.amount}>{item.amount}</span>
                                    <svg className={classes.rub} width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 22H18" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M11 27V5H18.5C20.2239 5 21.8772 5.68482 23.0962 6.90381C24.3152 8.12279 25 9.77609 25 11.5C25 13.2239 24.3152 14.8772 23.0962 16.0962C21.8772 17.3152 20.2239 18 18.5 18H7" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </section>
                            </section>
                            <section className={classes.created}>
                                {formatUtcToMsk(item.createdAt || item.actualAt)} (мск)
                            </section>
                            {
                                canDelete
                                    &&
                                <section className={classes.delete}>
                                    <DeleteAction
                                        onDelete={() => onDelete(item)}
                                        questionText={`Удалить ${item.type === 'bonus' ? bonusLabelLower : penaltyLabelLower}?`}
                                        errorText={`Ошибка при удалении ${item.type === 'bonus' ? bonusLabelLower : penaltyLabelLower}`}
                                        successText={`${item.type === 'bonus' ? bonusLabel : penaltyLabel} удален`}
                                    />
                                </section>
                            }
                        </section>
                        <section className={classes.comment}>
                            <LabelText
                                label="Комментарий"
                                text={item.comment}
                            />
                            {renderMeta?.(item)}
                        </section>
                    </section>
                )}
            </section>
        </section>
    )
}
